// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__Api from "../../../core/Api.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__NavbarCabinetLink from "./NavbarCabinetLink.js";
import * as Buhta_landing__NavbarMenuItem from "./NavbarMenuItem.js";
import * as Buhta_landing__NavbarMenuItemDropdown from "./NavbarMenuItemDropdown.js";
import * as Buhta_landing__NavbarMenuMobile from "./NavbarMenuMobile.js";
import * as Buhta_landing__Preheader from "../../../components/landing/preheader/Preheader.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function Navbar(Props) {
  let theme = Props.theme;
  let setBodyFixed = Props.setBodyFixed;
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match = React.useState(function () {
    return false;
  });
  const setMobileMenuActive = match[1];
  const mobileMenuActive = match[0];
  const match$1 = React.useState(function () {
    return false;
  });
  const setCabinetMenuActive = match$1[1];
  const cabinetMenuActive = match$1[0];
  const country = Buhta_landing__Route.getCountry(undefined);
  const countryStr = Buhta_models__Locale.toCountryString(country);
  const language = Buhta_landing__Route.getLanguage(undefined);
  const languageStr = Buhta_models__Locale.toString(language);
  const match$2 = Buhta_landing__Content.Context.useContent(undefined);
  const dispatchContent = match$2[1];
  const menus = match$2[0].mainMenus;
  React.useEffect((function () {
    const __x = Buhta_landing__Api.mainMenu(languageStr, countryStr);
    $$Promise.get(__x, (function (resp) {
      Buhta_landing__Api.handleResponse(resp, dispatchContent, undefined);
    }));
  }), [
    languageStr,
    country
  ]);
  React.useEffect((function () {
    if (deviceType === "mobile" && (mobileMenuActive || cabinetMenuActive)) {
      Curry._1(setBodyFixed, (function (param) {
        return true;
      }));
    } else {
      Curry._1(setBodyFixed, (function (param) {
        return false;
      }));
    }
  }), [
    deviceType,
    mobileMenuActive,
    cabinetMenuActive
  ]);
  const bg = theme === "dark" ? "bg-black-landing" : (
      theme === "gray" ? "bg-gray-pale" : "bg-white"
    );
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx(Buhta_landing__Preheader.make, {
        theme: theme
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_landing__Link.make, {
            route: {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: /* Home */ 0
            },
            className: "h-full flex items-center",
            onLinkClicked: (function (param) {
              Curry._1(setMobileMenuActive, (function (param) {
                return false;
              }));
              Curry._1(setCabinetMenuActive, (function (param) {
                return false;
              }));
            }),
            children: theme === "dark" ? JsxRuntime.jsx("img", {
                className: "h-6 ml-6 lg:ml-10",
                src: StaticAsset.src("/static/icons/logo-white.svg")
              }) : JsxRuntime.jsx("img", {
                className: "h-6 ml-6 lg:ml-10",
                src: StaticAsset.src("/static/icons/logo-black.svg")
              })
          }),
          JsxRuntime.jsx("div", {
            children: Belt__Belt_List.toArray(Stdlib__List.mapi((function (index, item) {
              const url = "/" + (item.country + ("/" + (languageStr + Belt__Belt_Option.getWithDefault(item.link, ""))));
              const match = item.type_;
              switch (match) {
                case "dropdown" :
                  const list = item.menu_items;
                  const Key = "menu_item_dropdown_" + String(index);
                  return JsxRuntime.jsx(Buhta_landing__NavbarMenuItemDropdown.make, {
                    label: item.name,
                    list: list,
                    theme: theme,
                    idx: index
                  }, Key);
                case "link" :
                  const Key$1 = "menu_item_" + String(index);
                  return JsxRuntime.jsx(Buhta_landing__NavbarMenuItem.make, {
                    label: item.name,
                    color: theme === "dark" ? "text-white" : "text-black-landing",
                    path: url
                  }, Key$1);
                default:
                  const Key$2 = "menu_item_" + String(index);
                  return JsxRuntime.jsx("span", {
                    children: "item"
                  }, Key$2);
              }
            }), menus)),
            className: "hidden md:flex"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_landing__NavbarCabinetLink.make, {
                theme: theme,
                cabinetMenuActive: cabinetMenuActive,
                setCabinetMenuActive: setCabinetMenuActive,
                setMobileMenuActive: setMobileMenuActive
              }),
              deviceType === "mobile" || deviceType === "tablet" ? (
                  mobileMenuActive ? JsxRuntime.jsx("img", {
                      className: "ml-6 md:hidden",
                      src: StaticAsset.src("/static/icons/menu-mobile-active.svg"),
                      onClick: (function (param) {
                        Curry._1(setMobileMenuActive, (function (param) {
                          return !mobileMenuActive;
                        }));
                        Curry._1(setCabinetMenuActive, (function (param) {
                          return false;
                        }));
                      })
                    }) : (
                      theme === "dark" ? JsxRuntime.jsx("img", {
                          className: "ml-6 md:hidden",
                          src: StaticAsset.src("/static/icons/menu-mobile-white.svg"),
                          onClick: (function (param) {
                            Curry._1(setMobileMenuActive, (function (param) {
                              return !mobileMenuActive;
                            }));
                            Curry._1(setCabinetMenuActive, (function (param) {
                              return false;
                            }));
                          })
                        }) : JsxRuntime.jsx("img", {
                          className: "ml-6 md:hidden",
                          src: StaticAsset.src("/static/icons/menu-mobile.svg"),
                          onClick: (function (param) {
                            Curry._1(setMobileMenuActive, (function (param) {
                              return !mobileMenuActive;
                            }));
                            Curry._1(setCabinetMenuActive, (function (param) {
                              return false;
                            }));
                          })
                        })
                    )
                ) : null
            ],
            className: "mr-6 lg:mr-10 flex items-center"
          })
        ],
        className: "h-16 lg:h-20 flex justify-between " + bg
      }),
      (deviceType === "mobile" || deviceType === "tablet") && mobileMenuActive ? JsxRuntime.jsx(Buhta_landing__NavbarMenuMobile.make, {
          menus: menus,
          setMobileMenuActive: setMobileMenuActive
        }) : null
    ]
  });
}

const make = Navbar;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
